import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);




export default class HistoryTimeline {
	constructor() {
		this.historyTimeline = document.querySelector('.history-timeline');

		if (!this.historyTimeline) return;

		this.tl = gsap.timeline({
			
		});

		window.addEventListener('load', () => {
			this._init();
			this._heroScrollTrigger();
		});
	}
	_init() {
		this.tl.from(this.historyTimeline, {
			autoAlpha: 0,
			duration: 1.5,
		});
	}
	_heroScrollTrigger() {
		const items = this.historyTimeline.querySelectorAll('.history-timeline__item');
		const container = this.historyTimeline.querySelector('.history-timeline__view');
		const controls = this.historyTimeline.querySelectorAll('.history-timeline__controls-year');
		
		// Create snap points for the entire timeline (only on devices 1199px and above)
		ScrollTrigger.matchMedia({
			"(min-width: 1199px)": function() {
				ScrollTrigger.create({
					trigger: container,
					start: "top top",
					end: "bottom bottom",
					snap: {
						snapTo: gsap.utils.snap(1 / (items.length - 1)),
					},
				});
			}
		});

		// Individual triggers for each item to handle active states
		items.forEach((item, index) => {

			const itemTl = gsap.timeline({
				paused: true,
				defaults:{
					duration: 1.5,
					ease: "power1.inOut",
					delay: 0.05,
				}
			});

			itemTl.from(item.querySelector('.history-timeline__item-content').querySelectorAll('*'), {
				y: "40px",
				opacity: 0,
				delay: 0.05,
				duration: 1,
				stagger: .5,
			})
			itemTl.from(item.querySelector('.history-timeline__item-image-1'), {
				duration: 2.5,
				y: "50px",
				opacity: 0,
				delay: 0.3,
				ease: "back.out(1.5)",
			}, '1')
			itemTl.from(item.querySelector('.history-timeline__item-image-2'), {
				duration: 3,
				y: "-50px",
				opacity: 0,
				delay: 0.35,
				ease: "back.out(1.5)",
			}, '1.5')

			ScrollTrigger.create({
				trigger: item,
				start: "top center",
				end: "bottom center",
				onEnter: () => {
					// Remove active from all items first
					document.querySelectorAll('.history-timeline__controls-year').forEach(btn => {
						btn.classList.remove('active');
					});
					
					// Add active to current item
					document.getElementById(`history-timeline__controls-year-${index + 1}`).classList.add('active');

					// Animate item
					itemTl.play();
				},
				onEnterBack: () => {
					// Remove active from all items first
					document.querySelectorAll('.history-timeline__controls-year').forEach(btn => {
						btn.classList.remove('active');
					});
					// Add active to current item
					document.getElementById(`history-timeline__controls-year-${index + 1}`).classList.add('active');

					// Animate item
					itemTl.play();
				},
				onLeave: () => {
					// Animate item reversed
					itemTl.reverse();
				},
				onLeaveBack: () => {
					// Animate item reversed
					itemTl.reverse();
				}
			});
		});

		controls.forEach((control, index) => {
			control.addEventListener('click', () => {
				gsap.to(window, { duration: 1.75, scrollTo: `#history-timeline__item-${index + 1}`, ease: "power4.inOut" });
			});
		});

	}
}
